<template>
  <div class="d-flex flex-column">
    <!-- v-b-toggle="`${officer.id}-${task.id}`" -->
    <div
      v-b-toggle="`${officer.id}-${task.activity_id}`"
      class="d-flex gap-3"
    >
      <div class="d-flex flex-column flex-grow-1 gap-1">
        <span
          class="font-weight-bold text-dark"
          style="font-size: 0.8rem;"
        >
          {{ task.activity?.activity_name }}
        </span>
        <div class="flex-grow-1 d-flex flex-column justify-content-end gap-1 mt-2">
          <div
            class="d-flex justify-content-between"
            style="font-size: 0.7rem;"
          >
            <div>
              <b class="text-muted">{{ task.events_count }}</b> of <b class="text-muted">{{ task.event_plan }}</b>
            </div>
            <div>
              <b :class="`text-${eventVariant}`">{{ eventProgress.toFixed(2) }}%</b>
            </div>
          </div>
          <BProgress
            :max="task.total"
            height="0.5rem"
          >
            <BProgressBar
              :value="eventProgress"
              :variant="eventVariant"
            />
          </BProgress>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'ASMDashboardOfficer',

  props: {
    officer: {
      type: Object,
      required: true
    },
    task: {
      type: Object,
      required: true
    }
  },

  computed: {
    eventProgress () {
      const events = this.task.events_count / this.task.event_plan
      if (isNaN(events) || !isFinite(events)) {
        return 0
      }

      return events * 100
    },

    eventVariant () {
      if (this.eventProgress >= 75) {
        return 'success'
      } else if (this.eventProgress >= 31) {
        return 'warning'
      } else if (this.eventProgress >= 0.01) {
        return 'danger'
      } else {
        return 'dark'
      }
    }
  }
}
</script>
